module.exports = __webpack_public_path__ + "7d5666906ec7060faa25efef6bf13f10.pdf";